import _ from 'lodash'

const encode = window.encodeURIComponent
const decode = window.decodeURIComponent

export const getQueryStringMap = (qs) => _.fromPairs(
  qs.split(/[?&]/)
    .filter(Boolean)
    .map(keyval => {
      const [key,val] = keyval.split('=').map(decode)
      if (val === undefined) return [key,true]
      else return [key,val]
    })
)

export const createQueryString = (map) => {
  return '?' + _.toPairs(map).map(x => x.join('=')).join('&')
}

export const updatedQueryString = (key,value,qs) => {
  const params = getQueryStringMap(qs)
  return (params[key] !== value)
    ? createQueryString({
      ...params,
      [key]:value
    })
    : !qs ? '?' : qs
}

export const urlParam = (p,qs) => getQueryStringMap(qs)[p]




// WEBPACK FOOTER //
// ./src/util/url.js